import { fetchAllServicePageEntries } from "../../../lib/services/builderServicePages.js";
import { normalizePathSlug } from "../../../lib/utils/url.js";

const enablePrerender = typeof process !== "undefined" && process.env.ENABLE_PRERENDER === "true";

export const prerender = enablePrerender;

/** @type {import('./$types.js').EntryGenerator} */
export async function entries() {
    if (!enablePrerender) {
        return [];
    }

    try {
        const results = await fetchAllServicePageEntries();

        return results
            .map((page) => normalizePathSlug(page?.data?.slug))
            .filter((slug) => slug && slug !== "/")
            .map((slug) => ({ slug: slug.replace(/^\//, "").replace(/\/$/, "") }));
    } catch (err) {
        console.error("[Service page entries] Failed to fetch Builder.io service pages:", err);
        throw err;
    }
}
